// extracted by mini-css-extract-plugin
export var auto = "_aa-1";
export var spinner = "_aa-0";